declare namespace $ {

	export class $bog_music_select extends $mol_select {
	}
	
}

//# sourceMappingURL=select.view.tree.d.ts.map